import React from 'react';
import { connect } from 'react-redux';

class Title extends React.Component {
    getCreatorName = () => {
        const { user } = this.props;
        return user.username;
    }

    render() {
        return (
            <div className="info-title">
                <h1>Publiceer je game</h1>
                <div className="creator-container">
                    <span>MAKER</span>
                    <span className="name">{this.getCreatorName()}</span>
                </div>
            </div>
        );
    }
}

Title.defaultProps = { };

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    user: state.user
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Title);